import { Stack } from '@atlaskit/primitives';
import PrivacyPolicy from './PrivacyPolicy';
import PrivacyCompliance from './PrivacyCompliance';
import Vendor from './Vendor';
import RedirectURL from './RedirectURL';
import { NumberOfPeople } from './NumberOfPeople';
import { AppAge } from './AppAge';
import { GraphQLNotConnectedFallback } from '../../../GraphQL/Fallback';

const Highlights = () => {
  return (
    <Stack space={'space.250'}>
      <PrivacyPolicy />
      <PrivacyCompliance />
      <Vendor />
      <GraphQLNotConnectedFallback errorText="Failed to retrieve number of people">
        <NumberOfPeople />
      </GraphQLNotConnectedFallback>
      <AppAge />
      <RedirectURL />
    </Stack>
  );
};

export default Highlights;
